import { action, computed, makeObservable, observable } from "mobx";
import { TemplateObservable } from "@/store/templates/TemplateObservable";
import { Uuid } from "@/domains/global/identifiers";
import { AppSubStore, AppSubStoreArgs } from "@/store/types";
import { toastModule } from "@/modules/toast";
import { UNTITLED_TEMPLATE_TITLE } from "@/domains/untitled/untitled";

export class DeleteTemplateModalStore extends AppSubStore {
  private onClose?: () => void;
  public isOpen: boolean = false;
  public templateId: Uuid | null = null;

  constructor(injectedDeps: AppSubStoreArgs, { onClose }: { onClose?: () => void }) {
    super(injectedDeps);

    this.onClose = onClose;

    makeObservable<this, "onClose">(this, {
      onClose: false,
      isOpen: observable,
      templateId: observable,
      template: computed,
      handleSubmit: action,
      open: action,
      close: action,
    });
  }

  get template(): TemplateObservable | undefined {
    if (!this.templateId) return undefined;
    return this.store.templates.get(this.templateId);
  }

  public async handleSubmit() {
    if (!this.template) return;
    const templateTitle = this.template.title;
    await this.template.delete();
    this.onClose?.();
    this.store.navigation.goToTemplates();
    toastModule.triggerToast({ content: `“${templateTitle || UNTITLED_TEMPLATE_TITLE}” deleted` });
  }

  public open({ templateId }: { templateId?: Uuid }) {
    if (!templateId) return;
    this.templateId = templateId;
    this.isOpen = true;
  }

  public close() {
    this.templateId = null;
    this.isOpen = false;
    this.onClose?.();
  }
}
